import { object } from 'yup';

import { personAddressValidation, stateValidation, zipValidationOptional } from './address';
import { emailValidationOptional, emailValidationRequired } from './email';
import { personNameValidation } from './personInfo';
import { phoneNumberValidationOptional, phoneNumberValidationRequired } from './phoneNumber';
import { hasFullSsnValidation } from './ssn';
import { optionalStringValidation } from './strings';

const originalLessee = 'Original Lessee ';

export const originalLesseeRequiredValidation = object().shape({
  ...personNameValidation(originalLessee),
  ...personAddressValidation(originalLessee),
  phone_number: phoneNumberValidationRequired(originalLessee),
  email: emailValidationRequired(originalLessee),
  has_full_ssn: hasFullSsnValidation('Original Lessee'),
});

// Used so the rep doesn't have to fill out all of the original lessee fields to submit a credit application
export const originalLesseeOptionalValidation = object().shape({
  first_name: optionalStringValidation,
  last_name: optionalStringValidation,
  address_line: optionalStringValidation,
  address_line2: optionalStringValidation,
  zip: zipValidationOptional(originalLessee),
  city: optionalStringValidation,
  state: stateValidation(originalLessee, false),
  county: optionalStringValidation,
  phone_number: phoneNumberValidationOptional(originalLessee),
  email: emailValidationOptional(originalLessee),
  has_full_ssn: hasFullSsnValidation('Original Lessee'),
});
